import React from "react";
import classnames from "classnames";
import { Alert } from "@instructure/ui-alerts";
import { useStateValue } from "../../context-store/AppStateProvider";
import styles from "./ProgressAlerts.module.scss";

export const PROGRESS_ALERT_VARIANTS = {
  SUCCESS: "success",
  INFO: "info",
  ERROR: "error",
};

const IasProgressAlerts = (props) => {
  const [{ progressAlert, showProgressAlert }] = useStateValue();

  return (
    <div className={classnames(styles.ProgressAlerts)}>
      {showProgressAlert && (
        <Alert
          variant={progressAlert.variant}
          timeout={
            progressAlert.variant === PROGRESS_ALERT_VARIANTS.SUCCESS ? 4000 : 0
          }
        >
          {progressAlert.message}
        </Alert>
      )}
    </div>
  );
};

export default IasProgressAlerts;
